document.addEventListener("DOMContentLoaded", function () {
  const toggles = document.querySelectorAll("[data-toggle-submenu]");

  toggles.forEach((toggle) => {
    const submenu = toggle.nextElementSibling;
    const icon = toggle.querySelector("img");

    toggle.addEventListener("click", function () {
      const isOpen = submenu.classList.contains("open");

      if (isOpen) {
        submenu.classList.remove("open");
        icon.src = "https://cdn.shopify.com/s/files/1/0755/4583/7822/files/add.png?v=1753262590";
      } else {
        submenu.classList.add("open");
        icon.src = "https://cdn.shopify.com/s/files/1/0755/4583/7822/files/minus.png?v=1753262590";
      }
    });
  });
});
